import leaflet, { LatLng, Polyline } from 'leaflet';
import { scaleToZoom } from '../../../../helpers/geometry/mapExtensions.helpers';
import { getVectorEndCoords, getVectorStartCoords } from '../../../../helpers/geometry/vectorTool.helpers';
import { AnnotationToolType } from '../../submodules/annotationTypes/models/annotationToolType';

export class PolylineEditorEx extends leaflet.Editable.PolylineEditor {
  isVector(): boolean {
    return this.feature.options.type === AnnotationToolType.VECTOR;
  }

  hasMiddleMarkers(): boolean {
    return !this.isVector();
  }

  extendBounds = (e: leaflet.Editable.VertexMouseEvent): void => {
    super.extendBounds(e);
    if (this.isVector()) {
      this.moveOrientationMarkers.call(this, e.vertex.latlngs);
    }
  };

  onDrag = (e: PointerEvent): void => {
    super.onDrag(e);
    if (this.isVector()) {
      this.moveOrientationMarkers.call(this, this.feature._latlngs);
    }
  };

  getElements = (): { startElement: Polyline | undefined; endElement: Polyline | undefined } => {
    const storeKey = this.feature.options.storeKey;
    let startElement: Polyline | undefined = undefined;
    let endElement: Polyline | undefined = undefined;

    this.map.eachLayer((layer) => {
      if (layer.options.storeKey && layer.options.storeKey === `${storeKey}-start`) {
        startElement = layer as unknown as Polyline | undefined;
      }
      if (layer.options.storeKey && layer.options.storeKey === `${storeKey}-end`) {
        endElement = layer as unknown as Polyline | undefined;
      }
    });
    return { startElement, endElement };
  };

  moveOrientationMarkers = ([start, end]: LatLng[]): void => {
    if (!this.feature.options.storeKey) {
      return;
    }

    const { startElement, endElement } = this.getElements();

    if (!startElement || !endElement) {
      return;
    }

    const zoom = scaleToZoom(this.map.getZoom());
    startElement._latlngs = getVectorStartCoords(start, zoom);
    endElement._latlngs = getVectorEndCoords([start, end], zoom);
    startElement.removeFrom(this.map);
    startElement.addTo(this.map);
    endElement.removeFrom(this.map);
    endElement.addTo(this.map);
  };
}
